import React, { useState } from 'react';
import { Game } from '../../models/Games';
import GenericButton from '../../components/GenericButton'; // Import the GenericButton
import GenericCheckbox from '../../components/GenericCheckbox';

interface AddGamePageProps {
  onSave: (value: any) => void;  // Save callback function
  data: Game;  // Game data for editing
}

const AddGamePage: React.FC<AddGamePageProps> = ({ data, onSave }) => {
  // Form state
  const [game, setGame] = useState<Game>(data);

  // Form error state
  const [errors, setErrors] = useState({
    name: '',
  });

  // Validation function for name
  const validateName = (value: string) => {
    return value.trim() === '' ? 'Name is required' : '';
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault(); // Prevent default form submission

    // Validate the form
    const nameError = validateName(game.name);

    if (nameError) {
      setErrors({ name: nameError });
      return; // Prevent form submission if there are validation errors
    }

    // If no errors, call the onSave prop to save the game
    onSave(game);
  };

  const handleGameTypeChange = (type: 'singalPatti' | 'digit' | 'barfi', checked: boolean) => {
    if (checked) {
      setGame({
        ...game,
        singlePattiSupported: type === 'singalPatti',
        digitSupported: type === 'digit',
        burfiSupported: type === 'barfi'
      });
    }
  };

  return (
    <div className="container mt-4">
      <form onSubmit={handleSubmit}> {/* Correct form submission handler */}
        <div className="mb-3">
          <label className="form-label">Game Name</label>
          <input
            type="text"
            className={`form-control ${errors.name ? 'is-invalid' : ''}`}
            value={game.name}
            onChange={(e) => {
              setGame({
                ...game,
                name: e.target.value,
              });
              setErrors({ ...errors, name: '' }); // Clear error when input changes
            }}
            required
          />
          {errors.name && <div className="invalid-feedback">{errors.name}</div>}
        </div>

        <div className="mb-3">
          <label className="form-label">Game Type</label>
          <GenericCheckbox
            label='Signal Patti Game'
            checked={game?.singlePattiSupported}
            onChange={(value) => handleGameTypeChange('singalPatti', value)}
          />

          <GenericCheckbox
            label='Is Digit Supported'
            checked={game?.digitSupported}
            onChange={(value) => handleGameTypeChange('digit', value)}
          />

          <GenericCheckbox
            label='Barfi Game'
            checked={game?.burfiSupported}
            onChange={(value) => handleGameTypeChange('barfi', value)}
          />
        </div>

        {/* <div className="mb-3">
          <label className="form-label">Game Mode</label>
        <GenericCheckbox
          label='Is Offline Game'
          checked={game?.offline}
          onChange={(value) => setGame({ ...game, offline: value })}
        />
        </div> */}

        {/* Replace standard button with GenericButton */}
        <GenericButton
          label="Save"
          onClick={() => handleSubmit} // Trigger handleSubmit on click
          disabled={game?.name?.trim() === ''} // Disable button if the name is empty
          type="primary" // You can change this to 'secondary' if needed
        />
      </form>
    </div>
  );
};

export default AddGamePage;
